import { ChangeDetectorRef, Component, DestroyRef, inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, ResolveStart, Router } from '@angular/router';
import { User } from 'api-clients/identity-server-api-client';
import { UserService } from 'src/shared/user.service';
import { globalWindow } from 'src/shared/window-globals';

@Component({
  selector: 'ez-layout-base',
  template: '',
})
export abstract class LayoutBaseComponent {
  user: User;
  firstRoutedPage = true;
  routerLoading = true;
  #deferredChromeCheck: GenericPromiseResponse[] = [];

  readonly #changeDetectorRef = inject(ChangeDetectorRef);
  protected readonly router = inject(Router);
  protected readonly userService = inject(UserService);
  readonly #destroyRef = inject(DestroyRef);

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof ResolveStart || event instanceof NavigationStart) {
        this.routerLoading = true;
        this.#changeDetectorRef.detectChanges();
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.routerLoading = false;
        this.firstRoutedPage = false;
        this.#changeDetectorRef.detectChanges();
      }
    });

    this.user = this.userService.user;
  }

  protected checkChromeExtension(): void {
    window.postMessage('isExtensionInstalled', '*');
    window.addEventListener('message', this.#handleMessage);
    this.#destroyRef.onDestroy(() => window.removeEventListener('message', this.#handleMessage));
    globalWindow.hasChromeExtension = new Promise<boolean>((resolve, reject) => {
      this.#deferredChromeCheck.push({ resolve, reject });
    });
  }

  #handleMessage = (event: MessageEvent): void => {
    if (event.data === true && this.#deferredChromeCheck.length) {
      this.#deferredChromeCheck[0].resolve(true);
      window.removeEventListener('message', this.#handleMessage);
    }
  };
}

interface GenericPromiseResponse {
  resolve: (value: boolean | PromiseLike<boolean>) => void;
  reject: (reason?: unknown) => void;
}
